import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from 'src/app/models/administration/user';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { FuelOrder } from 'src/app/models/fuel/fuel-order';
import { NotificationsService } from 'src/app/services/notifications.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { FunctionsService, HttpService, LocalStorageService, MenuBreadCrumb, MessageService, SessionService } from 'brainloper-ui';

@Component({
    selector: 'app-fuel-order-notification',
    templateUrl: './fuel-order-notification.component.html',
    styleUrls: ['./fuel-order-notification.component.scss'],
    standalone: false
})
export class FuelOrderNotificationComponent implements OnInit {
  
  private urlPostFO: string = `${EndpointDictionary.HistoricalFuel.CRUD_HISTORICAL_FUEL_DATA}`
  private urlCloseFO: string = `${EndpointDictionary.HistoricalFuel.HISTORICAL_FUEL_CLOSE}`


  public formCloseOrder: UntypedFormGroup
  private order
  public bodyOrden: FuelOrder = {}
  public bodyUsuarios: User[] = []
  public activa: number = 0
  public buttonActive: boolean = false
  public view: boolean = false
  public rol: string
  public currentOdometer: number = 0;
  public istraccarDevice: boolean = false;

  public menuBreadCrumb: Array<MenuBreadCrumb>

  constructor(
    private activeRoute: ActivatedRoute,
    private http: HttpService,
    private message: MessageService,
    private functioEter: FunctionsService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private functionEter: FunctionsService,
    private storage: LocalStorageService,
    private notificationsService: NotificationsService,
  ) {
    this.menuBreadCrumb = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: this.rol == 'Administrativo' || this.rol == 'root' || this.rol == 'Jefe Mantenimiento' ? "Ordenes de Combustible" : "O.C",
      router: this.rol == 'Administrativo' || this.rol == 'root' || this.rol == 'Jefe Mantenimiento' ? '/combustible/autoriza_comb' : null,
    },
    {
      name: "Cierre Combustible",
      current: true
    }
  ]
    this.rol = this.storage.get<string>('rol')
    this.formCloseOrder = this.formBuilder.group(
      {
        orderId: '',
        totalPrice: '',
        gallonPrice: '',
        billNumber: '',
        gallons: '',
        salesOrder: '',
        currentOdometer: 0
      }
    )
  }

  ngOnInit(): void {
    this.init()
  }

  async init() {
    this.message.openLoading('Cargando', 'Cargando información')
    this.activeRoute.queryParamMap
      .subscribe(async (params) => {
        this.order = { ...params };


        let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${this.order.params.id_orden}`)
        if (res) {
          this.bodyOrden = res[0]
          this.bodyOrden.date = this.functioEter.dateIso(res[0].date)
          this.formCloseOrder.get('orderId').setValue(this.bodyOrden.id)
          this.formCloseOrder.get('gallons').setValue(this.bodyOrden.gallons)
          this.formCloseOrder.get('totalPrice').setValue(this.bodyOrden.totalPrice)
          this.formCloseOrder.get('currentOdometer').setValue(this.bodyOrden.currentOdometer)
          this.currentOdometer = this.bodyOrden.currentOdometer
          
          // Deshabilitar el campo odómetro si existe traccarDeviceId
          this.istraccarDevice = !!this.bodyOrden.traccarDeviceId;
          if (this.istraccarDevice) {
            this.formCloseOrder.get('currentOdometer').disable();
          }
          
          this.view = true
          this.message.closeLoading()
        } else {
          this.message.Error('Error', res['message'])
          this.message.closeLoading()
        }
      }
      )
  }


  async closeOrder(form: FuelOrder) {
    this.buttonActive = true
    this.message.openLoading('Cargando', 'Cerrando Orden de Combustible')

    let res: Array<FuelOrder> = await this.http.getDataBody(`${this.urlPostFO}/${this.order.params.id_orden}`)
    if (res) {
      if (res[0].active == 1) {
        let fuelOrder: FuelOrder = res[0]
        for (let controls of Object.keys(form)) {
          if (controls === 'currentOdometer' && this.istraccarDevice) {
            // Si el odómetro está deshabilitado, mantener el valor original
            fuelOrder[controls] = res[0].currentOdometer
          } else {
            fuelOrder[controls] = form[controls]
          }
        }
        fuelOrder.date = this.functionEter.dateForm(res[0].date)
        this.closeFO(fuelOrder)
      } else {
        this.message.closeLoading()
        this.message.Warning('Advertencia', 'Esta orden ya fue cerrada')
        this.deleteFuelNotificationByUrl()
        setTimeout(() => {
          this.router.navigate(['/inicio'])
        }, 500);

      }
    }

  }

  close() {
    this.activa = 1
  }

  async closeFO(form: FuelOrder) {
    try {
      form.active = 0

      let messageError = null

      if (form.gallons <= 0)
        messageError = "Los Galones deben ser mayor a 0"

      if (!this.istraccarDevice && this.currentOdometer >= form.currentOdometer) {
        let msm = "El valor del medidor debe ser mayor que " + this.currentOdometer.toLocaleString()
        messageError = messageError ? messageError + " y " + msm : msm;
      }

      if (messageError) {
        this.message.Error("Error", messageError)
        this.message.closeLoading()
        this.buttonActive = false
        return
      }

      let res: GenericResponse = await this.http.putDataBody(`${this.urlCloseFO}`, form)
      if (res) {
        this.deleteFuelNotificationByUrl()
        this.message.closeLoading()
        setTimeout(() => {
          this.router.navigate(['/inicio'])
        }, 500);

      } else {
        this.message.closeLoading()
        this.message.Error('Error', res['message'])
      }
    } catch (error) {
      this.message.closeLoading()
      this.message.Error('Error', error)
    }
  }

  private deleteFuelNotificationByUrl() {
    this.notificationsService.deleteNotificationByUrl(`notificaciones/ordenCombustible?id_orden=${this.order.params.id_orden}`)
  }

  errorMessage() {
    this.message.Error('Error', 'complete los campos')
  }

  calculatePrice() {
    if (this.formCloseOrder.get('gallons').value != "" && this.formCloseOrder.get('gallonPrice').value != "") {
      let galones = parseInt(this.formCloseOrder.get('gallons').value)
      let precioGal = parseInt(this.formCloseOrder.get('gallonPrice').value)
      this.formCloseOrder.get('totalPrice').setValue((galones * precioGal).toString())

    }
  }

}
